import { AvatarController, type AvatarCatalogEntry } from './avatar-controller.js';

export type { AvatarCatalogEntry } from './avatar-controller.js';

const DEFAULT_AVATAR_CATALOG: AvatarCatalogEntry[] = [
    {
        id: 'default_sim',
        label: 'Default Knight',
        templateName: 'Avatar_Default_Knight',
    },
    {
        id: 'test_sim',
        label: 'Test Avatar',
        templateName: 'Avatar_Test',
    },
];

const DEFAULT_AVATAR_ID = 'default_sim';

function getSceneAvatarCatalog(): AvatarCatalogEntry[] {
    const controller = AvatarController.instance;
    if (controller && Array.isArray(controller.entries) && controller.entries.length > 0) {
        return controller.entries.map((entry) => ({
            id: String(entry.id ?? ''),
            label: String(entry.label ?? ''),
            templateName: String(entry.templateName ?? ''),
        }));
    }

    return DEFAULT_AVATAR_CATALOG.map((entry) => ({ ...entry }));
}

export function normalizeAvatarId(input: unknown): string {
    const raw = typeof input === 'string' ? input.trim() : '';
    const catalog = getSceneAvatarCatalog();
    if (!raw) {
        return catalog[0]?.id ?? DEFAULT_AVATAR_ID;
    }

    const found = catalog.find((entry) => entry.id === raw);
    return found ? found.id : (catalog[0]?.id ?? DEFAULT_AVATAR_ID);
}

export function getAvatarEntryById(avatarId: unknown): AvatarCatalogEntry {
    const normalized = normalizeAvatarId(avatarId);
    const catalog = getSceneAvatarCatalog();
    const found = catalog.find((entry) => entry.id === normalized);
    return found ?? catalog[0] ?? DEFAULT_AVATAR_CATALOG[0];
}

export function getAvatarCatalog(): AvatarCatalogEntry[] {
    const catalog = getSceneAvatarCatalog();
    return catalog.map((entry) => ({ ...entry }));
}
